import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../Components/ui/table";
import { DotsHorizontalIcon, CaretSortIcon } from "@radix-ui/react-icons";
import { Button } from "../../../Components/ui/button";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { StopwatchIcon, CheckIcon } from "@radix-ui/react-icons";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import { useDispatch, useSelector } from "react-redux";
import { setCreateBreadCrumb } from "../../../State/slices/AdvertiserAccountSlice";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Switch } from "../../../Components/ui/switch";
import CircularProgress from "@mui/material/CircularProgress";
import { useToast } from "../../../Components/ui/use-toast";
import { Toaster } from "../../../Components/ui/toaster";
import { RootState } from "@/src/State/store";
import { Card } from "../../../Components/ui/card";
import { convertUTCToLocal } from "../../../../src/utils/convertUTCToLocal";


export interface Plan {
  plan_id: number;
  planType: string;
  messages: number;
  price: number;
  name: string;
  planDesc: string;
  updated_at: string;
  status: string;
  countrySymbol: string;
}

interface ExistingPlans {
  countrySymbol: string;
  name: string;
}

const AdminPlans: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const adminApiUrl = useSelector((state: RootState) => state.authentication.adminUrl);
  const [isLoading, setIsLoading] = useState(true);

  // Separate states for Starter Plan table
  const [isAllSelectedStarter, setIsAllSelectedStarter] = useState(false);
  const [checkboxSelectedRowsStarter, setCheckboxSelectedRowsStarter] = useState<number[]>([]);

  // Separate states for Enterprise Plans table
  const [isAllSelectedEnterprise, setIsAllSelectedEnterprise] = useState(false);
  const [checkboxSelectedRowsEnterprise, setCheckboxSelectedRowsEnterprise] = useState<number[]>([]);

  const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<number | null>(null);
  const [currentPlans, setCurrentPlans] = useState<Plan[]>([]);
  const [isPriceSortedAsc, setIsPriceSortedAsc] = useState<boolean>(true);
  const [isNameSortedAsc, setIsNameSortedAsc] = useState<boolean>(true);
  const [isUpdatedAtSortedAsc, setIsUpdatedAtSortedAsc] = useState<boolean>(true);
  const [isStatusSortedAsc, setIsStatusSortedAsc] = useState<boolean>(true);
  const [isMessagesSortedAsc, setIsMessagesSortedAsc] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [isLoadingFullScreen, setIsLoadingFullScreen] = useState(false);
  const [existingPlansList, setExistingPlansList] = useState<ExistingPlans[]>([]);
  const [displayedPlans, setDisplayedPlans] = useState<Plan[]>([]);

  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
      const accountId = useSelector((state: RootState) => state.authentication.account_id);
    const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);


  
  const workspaceTimezone = useSelector((state:RootState)=>state.authentication.workspaceTimezone);

  const totalPages = Math.ceil(currentPlans.length / rowsPerPage);

      const fetchAllPlans = async () => {
      if (!adminApiUrl) return;

      setIsLoading(true);
      try {
        const plansResponse = await axios.get(`${adminApiUrl}/GetPlansDetails`);

        if (plansResponse.data?.plansList) {
          const allPlans = plansResponse.data.plansList.map((plan: any) => ({
            plan_id: plan.planId,
            planType: plan.planType,
            messages: plan.msgCount,
            price: plan.planAmount,
            name: plan.planName,
            planDesc: plan.planDesc,
            updated_at: plan.lastUpdatedTime,
            status: plan.status,
            countrySymbol: plan.currency,
          }));

          const freeTier = allPlans.filter((plan: Plan) => plan.planType === 'freetier');
          const enterprise = allPlans.filter((plan: Plan) => plan.planType === 'paidplan');

          setDisplayedPlans(freeTier);
          setCurrentPlans(enterprise);

          const extractedPlans = allPlans.map((plan: Plan) => ({
            countrySymbol: plan.countrySymbol,
            name: plan.name,
          }));
          setExistingPlansList(extractedPlans);
        } else {
          setDisplayedPlans([]);
          setCurrentPlans([]);
        }

      } catch (error) {
        console.error("Error fetching plans:", error);
        setDisplayedPlans([]);
        setCurrentPlans([]);
      } finally {
        setIsLoading(false);
      }
    };
  useEffect(() => {


    fetchAllPlans();
  }, [adminApiUrl]);

  const sortPlansByName = (setter: React.Dispatch<React.SetStateAction<Plan[]>>) => {
    setter((prev) => [...prev].sort((a, b) =>
      isNameSortedAsc ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
    ));
    setIsNameSortedAsc(!isNameSortedAsc);
  };

  const sortPlansByCredits = () => {
    setDisplayedPlans((prev) => [...prev].sort((a, b) =>
      isMessagesSortedAsc ? a.price - b.price : b.price - a.price
    ));
    setIsMessagesSortedAsc(!isMessagesSortedAsc);
  };

  const sortPlansByMessages = (setter: React.Dispatch<React.SetStateAction<Plan[]>>) => {
    setter((prev) => [...prev].sort((a, b) =>
      isMessagesSortedAsc ? a.messages - b.messages : b.messages - a.messages
    ));
    setIsMessagesSortedAsc(!isMessagesSortedAsc);
  };

  const sortPlansByUpdatedAt = (setter: React.Dispatch<React.SetStateAction<Plan[]>>) => {
    setter((prev) => [...prev].sort((a, b) =>
      isUpdatedAtSortedAsc
        ? new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime()
        : new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
    ));
    setIsUpdatedAtSortedAsc(!isUpdatedAtSortedAsc);
  };

  const sortPlansByPrice = () => {
    setCurrentPlans((prev) => [...prev].sort((a, b) =>
      isPriceSortedAsc ? a.price - b.price : b.price - a.price
    ));
    setIsPriceSortedAsc(!isPriceSortedAsc);
  };

  const sortPlansByStatus = () => {
    setCurrentPlans((prev) => [...prev].sort((a, b) => {
      const statusA = a.status === "Active" ? 1 : 0;
      const statusB = b.status === "Active" ? 1 : 0;
      return isStatusSortedAsc ? statusA - statusB : statusB - statusA;
    }));
    setIsStatusSortedAsc(!isStatusSortedAsc);
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleCheckboxRowSelectStarter = (id: number) => {
    setCheckboxSelectedRowsStarter((prev) => {
      const newSelectedRows = prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id];
      setIsAllSelectedStarter(newSelectedRows.length === displayedPlans.length);
      return newSelectedRows;
    });
  };

  const handleCheckboxRowSelectEnterprise = (id: number) => {
    setCheckboxSelectedRowsEnterprise((prev) => {
      const newSelectedRows = prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id];
      setIsAllSelectedEnterprise(newSelectedRows.length === currentPlans.length);
      return newSelectedRows;
    });
  };

  const handleSelectAllStarter = () => {
    if (isAllSelectedStarter) {
      setCheckboxSelectedRowsStarter([]);
    } else {
      const allIds = displayedPlans.map((plan) => plan.plan_id);
      setCheckboxSelectedRowsStarter(allIds);
    }
    setIsAllSelectedStarter(!isAllSelectedStarter);
  };

  const handleSelectAllEnterprise = () => {
    if (isAllSelectedEnterprise) {
      setCheckboxSelectedRowsEnterprise([]);
    } else {
      const allIds = currentPlans.map((plan) => plan.plan_id);
      setCheckboxSelectedRowsEnterprise(allIds);
    }
    setIsAllSelectedEnterprise(!isAllSelectedEnterprise);
  };

const handleEdit = (plan_id: number) => {
  const planToEdit = displayedPlans.find((plan) => plan.plan_id === plan_id);
  if (!planToEdit) {
    toast({
      title: "Error",
      description: "Plan not found.",
    });
    return;
  }

  if (!adminApiUrl) {
    toast({
      title: "Error",
      description: "API URL is not configured.",
    });
    return;
  }

  const planDetails = {
    plan_id,
    name: planToEdit.name,
    messages: planToEdit.messages.toString(),
    per_message: planToEdit.messages ? (planToEdit.price / planToEdit.messages).toFixed(4) : "0",
    price: planToEdit.price,
    planDesc: planToEdit.planDesc, // Add planDesc
    countrySymbol: planToEdit.countrySymbol,
    from: location.pathname,
    isFreeTier: true,
  };

  navigate("/adminNavbar/FreeTier", {
    state: planDetails,
  });
};

  const handleDeletePlan = (plan_id: number) => {
    setSelectedPlan(plan_id);
    setIsAlertOpen(true);
  };

  const handleClose = () => {
    setIsAlertOpen(false);
  };

  const handleConfirmDelete = () => {
    setIsAlertOpen(false);
  };

  const handleStatusToggle = (plan_id: number, currentStatus: string) => {
    setIsLoadingFullScreen(true);
    const newStatus = currentStatus === "active" ? "inactive" : "active";
axios.post(`${adminApiUrl}/UpdateStatusForPlansUsingToggle`, { planId: plan_id, status: newStatus, workspaceId :workspaceId , accountId:accountId })
      .then((response) => {
        if (response.status === 200) {
          setCurrentPlans((prevPlans) =>
            prevPlans.map((plan) =>
              plan.plan_id === plan_id ? { ...plan, status: newStatus } : plan
            )
          );
          setDisplayedPlans((prevPlans) =>
            prevPlans.map((plan) =>
              plan.plan_id === plan_id ? { ...plan, status: newStatus } : plan
            )
          );
          toast({
            title: "Success",
            description: "Plan updated successfully",
          });
          fetchAllPlans();
        }
      })
      .catch((error) => {
        toast({
          title: "Error",
          description: "Something went wrong, Please try again.",
        });
      })
      .finally(() => {
        setIsLoadingFullScreen(false);
      });
  };

const getMessageValue = (input?: string | number) => {
  // Convert input to string and handle undefined
  const safeInput = input == null ? "" : String(input).trim();

  if (safeInput === "Unlimited messages") {
    return "N/A";
  }

  const number = safeInput.match(/\d+/);
  if (number) {
    return parseInt(number[0]).toLocaleString("en-US");
  }

  return safeInput;
};

  const handleMenuToggle = (rowId: number) => {
    setOpenMenuRowId((prev) => (prev === rowId ? null : rowId));
  };

  const displayedPlansPaginated = displayedPlans.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="relative p-4">
      <Toaster />
      {isLoading && (
        <div className="flex flex-col items-center justify-center h-[500px]">
          <CircularProgress color="primary" />
        </div>
      )}

      <div className="fixed flex justify-end items-end right-0 top-[-15px] z-20 p-4 mr-2">
        {!isLoading && (
          <Button
            onClick={() => {
              dispatch(setCreateBreadCrumb(true));
              navigate("/adminNavbar/createplans", {
                state: { plansList: existingPlansList, from: location.pathname },
              });
            }}
            className="w-17 text-sm text-[#F8FAFC] font-medium h-[35px] mt-[10px]"
          >
            New Plan
          </Button>
        )}
      </div>

      <div className="relative">
        {!isLoading && (
          <>
            <Card className="bg-white rounded-md border overflow-hidden shadow-sm mb-4 p-1 y-1.5">
              <div className="flex flex-col gap-2" style={{ margin: '20px' }}>
                <h2 className="text-lg font-bold text-left">Starter Plan</h2>
                <div className="bg-white rounded-md border overflow-hidden shadow-sm">
                  {displayedPlans.length > 0 ? (
                    <div className="max-h-[60vh] overflow-y-auto">
                      <Table className="rounded-xl whitespace-nowrap border-gray-200" style={{ color: "#020202", fontSize: "15px" }}>
                        <TableHeader className="text-center text-[14px] font-medium">
                          <TableRow>
                            <TableHead style={{ width: "40%" }}>
                              <div className="flex items-center gap-6 justify-start cursor-pointer" onClick={() => sortPlansByName(setDisplayedPlans)}>
                                <input
                                  type="checkbox"
                                  className={`text-muted-foreground ${isAllSelectedStarter ? "accent-gray-700 bg-grey-700 text-red-500" : ""}`}
                                  checked={isAllSelectedStarter}
                                  onChange={handleSelectAllStarter}
                                />
                                Name
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "15%" }}>
                              <div className="flex items-center gap-2 justify-start cursor-pointer" onClick={sortPlansByCredits}>
                                Credits
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "15%" }}>
                              <div className="flex items-center gap-2 justify-start cursor-pointer" onClick={() => sortPlansByMessages(setDisplayedPlans)}>
                                Messages
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "20%" }}>
                              <div className="flex items-center gap-2 justify-start ml-3 cursor-pointer" onClick={() => sortPlansByUpdatedAt(setDisplayedPlans)}>
                                Updated at
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "10%" }}></TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody className="text-left text-[14px] font-normal text-[#020617]">
                          {displayedPlansPaginated.map((plan) => {
                            const isSelected = checkboxSelectedRowsStarter.includes(plan.plan_id);
                            return (
                              <TableRow key={plan.plan_id} className={`${isSelected ? "bg-gray-200" : ""}`}>
                                <TableCell className="py-4">
                                  <div className="flex items-center justify-start gap-4">
                                    <input
                                      type="checkbox"
                                      className={`accent-gray-700 bg-grey-700 text-red-500 ${isAllSelectedStarter ? "accent-gray-700 bg-grey-700 text-red-500" : ""}`}
                                      checked={isSelected}
                                      onChange={() => handleCheckboxRowSelectStarter(plan.plan_id)}
                                    />
                                    <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>{plan.name}</span>
                                  </div>
                                </TableCell>
                                <TableCell className="py-4">
                                  <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>{plan.price}</span>
                                </TableCell>
                                <TableCell className="py-4">
                                  <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>{plan.messages}</span>
                                </TableCell>
                                <TableCell className="py-4">
                                  <div className="flex items-center justify-start gap-2 ml-2.5">
                                    <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>
                                      {new Date(plan.updated_at).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" })} •{" "}
                                      {new Date(plan.updated_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                    </span>
                                  </div>
                                </TableCell>
                                <TableCell className="py-4">
                                  <DropdownMenu>
                                    <DropdownMenuTrigger>
                                      <DotsHorizontalIcon style={{ color: "#020617" }} className="cursor-pointer w-5 h-5" onClick={() => handleMenuToggle(plan.plan_id)} />
                                    </DropdownMenuTrigger>
                                    {openMenuRowId === plan.plan_id && (
                                      <DropdownMenuContent className="bg-white border border-gray-200 shadow-md rounded-md w-24">
                                        <DropdownMenuItem
                                          className="px-4 py-3 text-gray-900 hover:bg-gray-100 cursor-pointer"
                                          onClick={() => handleEdit(plan.plan_id)}
                                        >
                                          Edit
                                        </DropdownMenuItem>
                                      </DropdownMenuContent>
                                    )}
                                  </DropdownMenu>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center justify-center h-[500px]">
                      <h2 className="text-[24px] font-semibold mb-1 text-[#000000]">No plans found</h2>
                    </div>
                  )}
                </div>
              </div>
            </Card>

            <Card className="bg-white rounded-md border overflow-hidden shadow-sm mb-4 p-0 y-1.5">
              <div className="flex flex-col gap-2" style={{ margin: '20px' }}>
                <h2 className="text-lg font-bold text-left">Enterprise Plans</h2>
                <div className="bg-white rounded-md border overflow-hidden shadow-sm">
                  {currentPlans.length > 0 ? (
                    <div className="max-h-[300px] overflow-y-auto">
                      <Table className="rounded-xl whitespace-nowrap border-gray-200" style={{ color: "#020202", fontSize: "15px" }}>
                        <TableHeader className="text-center text-[14px] font-medium">
                          <TableRow>
                            <TableHead style={{ width: "40%" }}>
                              <div className="flex items-center gap-6 justify-start cursor-pointer">
                                <input
                                  type="checkbox"
                                  className={`text-muted-foreground ${isAllSelectedEnterprise ? "accent-gray-700 bg-grey-700 text-red-500" : ""}`}
                                  checked={isAllSelectedEnterprise}
                                  onChange={handleSelectAllEnterprise}
                                  onClick={(e) => e.stopPropagation()}
                                />
                                <span className="flex items-center gap-1">
                                  Name
                                  <CaretSortIcon
                                    className="cursor-pointer"
                                    onClick={() => sortPlansByName(setCurrentPlans)}
                                  />
                                </span>
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "10%" }}>
                              <div className="flex items-center gap-2 justify-start cursor-pointer" onClick={sortPlansByStatus}>
                                Status <CaretSortIcon className="cursor-pointer" />
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "15%" }}>
                              <div className="flex items-center gap-2 justify-start cursor-pointer" onClick={sortPlansByPrice}>
                                Price <CaretSortIcon className="cursor-pointer" />
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "15%" }}>
                              <div className="flex items-center gap-2 justify-start cursor-pointer" onClick={() => sortPlansByMessages(setCurrentPlans)}>
                                Messages <CaretSortIcon className="cursor-pointer" />
                              </div>
                            </TableHead>
                            <TableHead style={{ width: "20%" }}>
                              <div className="flex items-center gap-2 justify-start ml-3 cursor-pointer" onClick={() => sortPlansByUpdatedAt(setCurrentPlans)}>
                                Updated at <CaretSortIcon className="cursor-pointer" />
                              </div>
                            </TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody className="text-left text-[14px] font-normal text-[#020617]">
                          {currentPlans.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((plan) => {
                            const isSelected = checkboxSelectedRowsEnterprise.includes(plan.plan_id);
                            return (
                              <TableRow key={plan.plan_id} className={`${isSelected ? "bg-gray-200" : ""}`}>
                                <TableCell className="py-4">
                                  <div className="flex items-center justify-start gap-4">
                                    <input
                                      type="checkbox"
                                      className={`accent-gray-700 bg-grey-700 text-red-500 ${isAllSelectedEnterprise ? "accent-gray-700 bg-grey-700 text-red-500" : ""}`}
                                      checked={isSelected}
                                      onChange={() => handleCheckboxRowSelectEnterprise(plan.plan_id)}
                                    />
                                    <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>{plan.name}</span>
                                  </div>
                                </TableCell>
                                <TableCell className="py-4">
                                  <div className="flex items-center justify-start">
                                    <Switch
                                      checked={plan.status === "active"}
                                      onCheckedChange={(checked) => handleStatusToggle(plan.plan_id, plan.status)}
                                      className="bg-gray-200"
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="py-4">
                                  <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>
                                    {Number(plan.price).toLocaleString()} {plan.countrySymbol}
                                  </span>
                                </TableCell>
                                <TableCell className="py-4">
                                  <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>{getMessageValue(plan.messages.toString())}</span>
                                </TableCell>
                                <TableCell className="py-4">
                                  {/* <div className="flex items-center justify-start gap-2 ml-2.5">
                                    <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>
                                      {new Date(plan.updated_at).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" })} •{" "}
                                      {new Date(plan.updated_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                    </span>
                                  </div> */}
                                  <div className="flex items-center justify-start gap-2 ml-2.5">
  <span style={{ color: "#020617", fontSize: "14px", fontWeight: "400" }}>
    {convertUTCToLocal(plan.updated_at, workspaceTimezone).localDate} •{" "}
    {convertUTCToLocal(plan.updated_at, workspaceTimezone).localTime}
  </span>
</div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center justify-center h-[500px]">
                      <h2 className="text-[24px] font-semibold mb-1 text-[#000000]">No plans found</h2>
                    </div>
                  )}
                </div>
              </div>
            </Card>

            {(currentPlans.length > 0 || displayedPlans.length > 0) && (
              <div className="flex justify-between items-center mt-4">
                <div className="flex items-center space-x-2 text-gray-500 text-sm">
                  <span>{`${(currentPage - 1) * rowsPerPage + 1}-${Math.min(currentPage * rowsPerPage, currentPlans.length)} of ${currentPlans.length} row(s) selected`}</span>
                </div>
                <div className="flex items-center space-x-4 font-medium text-sm">
                  <span className="text-[#020617] font-medium text-[14px]">Rows per page</span>
                  <div className="relative inline-block ml-2">
                    <select
                      className="cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500"
                      style={{ width: "60px", height: "30px", textAlign: "left", fontSize: "12px", fontWeight: "400", borderColor: "#E5E7EB", boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)" }}
                      value={rowsPerPage}
                      onChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      {[5, 10, 20].map((num) => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>
                  <div className="ml-4 mr-4">
                    <span className="text-[#020617] text-[14px] font-medium">{`Page ${currentPage} of ${totalPages}`}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      disabled={currentPage === 1}
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === 1 ? "cursor-not-allowed bg-gray-100" : "hover:bg-gray-200"}`}
                      onClick={() => handlePageChange(1)}
                    >
                      «
                    </button>
                    <button
                      disabled={currentPage === 1}
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === 1 ? "cursor-not-allowed bg-gray-100" : "hover:bg-gray-200"}`}
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      ‹
                    </button>
                    <button
                      disabled={currentPage === totalPages}
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === totalPages ? "cursor-not-allowed bg-gray-100" : "hover:bg-gray-200"}`}
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      ›
                    </button>
                    <button
                      disabled={currentPage === totalPages}
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === totalPages ? "cursor-not-allowed bg-gray-200" : "hover:bg-gray-200"}`}
                      onClick={() => handlePageChange(totalPages)}
                    >
                      »
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <Dialog
        open={isAlertOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ "& .MuiPaper-root": { borderRadius: "10px" } }}
      >
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this plan?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outline" className="w-24" onClick={handleClose}>Cancel</Button>
          <Button className="w-24" onClick={handleConfirmDelete} autoFocus>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdminPlans;

function setEnterprisePlans(enterprise: any) {
  throw new Error("Function not implemented.");
}